export default {
  title: 'Device Key',
  content: 'There is a key assigned to this device, would you like to remove it?',
  yes: 'Yes, remove the key',
  no: 'No, keep it',
};
